import { createStyles } from "antd-style";

const useHeaderStyles = createStyles(({ css }) => {
  return {
    header: css`
      width: 100%;
      height: 44px;
      min-height: 44px;
      position: sticky;
      top: 0;
      z-index: 30;
      background: var(--Global-token-Bg-colorBgBase, #fff);

      .icon {
        position: absolute;
        top: 0;
        left: 16px;
        margin: 8px;
        border-radius: 100%;

        &:active {
          background-color: var(--neutral-gray-6);
        }

        svg {
          cursor: pointer;
        }
      }
      .headerText {
        color: var(--Global-token-Text-colorText, rgba(0, 0, 0, 0.88));
        text-align: center;
        font-feature-settings: "liga" off, "clig" off;
        text-overflow: ellipsis;

        /* MD/Title 2/Medium */
        font-size: 17px;
        font-style: normal;
        font-weight: 600;
        line-height: 90%; /* 20.4px */
      }
    `,
  };
});
export default useHeaderStyles;
